import React from "react";
import { Table } from "react-bootstrap";
import { Loader } from "./Loader";
import { BASE_URL } from "../store/constant";
import Axios from "axios";
import map from "lodash/map";
import get from "lodash/get";
import find from "lodash/find";
import _ from "lodash";
import { toast } from "react-toastify";
import styled from "styled-components";
import moment from "moment";
import { exportTableToExcel } from "../utils";
import {
  FaCalendarAlt,
  FaMapMarkerAlt,
  FaUniversity,
  FaUser,
  FaVenusMars,
  FaThLarge,
} from "react-icons/fa";

const Wrapper = styled.div`
  position: relative;
  & h3 {
    text-align: center;
    display: none;
  }

  @media print {
    h3 {
      display: block;
    }
  }

  table {
    width: 100%;
    border-collapse: separate;
    border-spacing: 0;
    border: 1px solid #e6e6e6; /*  light outer border */
    background-color: #ffffff;
  }

  * {
    box-sizing: border-box;
    font-family: "Segoe UI", Tahoma, Geneva, Verdana, sans-serif;
  }

  td {
    text-align: left;
  }
  /* wrap long city names only */
  .city-name {
    max-width: 220px;
    white-space: normal;
    overflow-wrap: anywhere;
    word-break: break-word;
  }
  tr td:first-child {
    text-align: center;
    max-width: 70px;
  }
  tbody tr:hover {
    background-color: #d0e4ff;
  }

  /* =========================
   PAGINATION FOOTER
========================= */

  .pagination-footer {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 10px 22px;
    background: #f8fbff;
    border-top: 1px solid #dbe5f0;
    min-height: 64px;
  }

  /* Showing entries text */
  .entries-info {
    font-size: 14px;
    color: #64748b;
    font-weight: 500;
  }

  /* Center page */
  .page-number {
    font-size: 15px;
    font-weight: 600;
    color: #1e293b;
    min-width: 80px;
    text-align: center;
  }

  /* Buttons */
  .pagination-btn {
    min-width: 110px;
    padding: 10px 18px;
    border: 1px solid #1769ff;
    border-radius: 8px;
    background: #ffffff;
    color: #1769ff;
    font-size: 14px;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.2s ease;
  }

  /* Next button */
  .pagination-btn.next-btn {
    background: linear-gradient(135deg, #1769ff, #0066ff);
    color: #ffffff;
    border-color: #1769ff;
  }

  /* Hover */
  .pagination-btn:hover:not(:disabled) {
    transform: translateY(-1px);
    box-shadow: 0 4px 10px rgba(23, 105, 255, 0.2);
  }

  /* Disabled */
  .pagination-btn:disabled {
    background: #f1f5f9;
    color: #b8c2cc;
    border-color: #dbe2ea;
    cursor: not-allowed;
    box-shadow: none;
  }

  .beneficiary-header {
    background: linear-gradient(135deg, #063b68 0%, #002b49 100%);
    color: #ffffff;
    position: sticky;
    top: 0;
    z-index: 10;
  }

  .beneficiary-header th {
    padding: 8px 8px;
    text-align: center;
    font-size: 13px;
    font-weight: 600;
    border-right: 1px solid rgba(255, 255, 255, 0.2);
    border-bottom: none;
    white-space: nowrap;
  }

  .beneficiary-header th:last-child {
    border-right: none;
  }

  .beneficiary-header th {
    vertical-align: middle;
  }

  .beneficiary-header th svg {
    display: inline-block;
    margin-right: 5px;
    font-size: 13px;
  }

  .beneficiary-header th span {
    vertical-align: middle;
  }

.beneficiary-modal .modal-dialog {
  max-width: 92%;
  width: 92%;
  margin: 1.5rem auto;
}

  .beneficiary-modal .modal-content {
    border: none;
    border-radius: 12px;
    overflow: hidden;
    box-shadow: 0 20px 50px rgba(0, 0, 0, 0.25);
  }

  .beneficiary-modal-header {
    background: linear-gradient(135deg, #1769ff 0%, #0066cc 100%);
    color: #fff;
    padding: 10px 20px;
    min-height: 50px;

    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .beneficiary-modal-title {
    margin: 0;
    font-size: 18px;
    font-weight: 700;
    color: #fff;
  }

  .beneficiary-modal-close {
    width: 32px;
    height: 32px;
    border-radius: 50%;

    border: 2px solid #fff;
    background: transparent;
    color: #fff;

    font-size: 20px;
    font-weight: 700;

    display: flex;
    align-items: center;
    justify-content: center;

    cursor: pointer;
  }

  .table-cell-with-icon {
    font-size: 13px;
    display: flex;
    align-items: center;
    gap: 6px;
  }

  .date-icon {
    color: #2196f3;
  }

  .district-icon {
    color: #ff7a00;
  }

  .ulb-icon {
    color: #16a34a;
  }

  .gender-icon {
    color: #1683ff;
  }

  .customTable tbody td a {
    color: #155eef;
    font-weight: 500;
    text-decoration: none;
  }

  .customTable tbody td a:hover {
    text-decoration: underline;
  }

  .customTable tbody td {
    color: #1f2937;
    font-size: 14px;
  }

  .component-badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;

  min-width: 48px;
  padding: 4px 8px;

  border-radius: 5px;

  background: #eee5ff;
  color: #6d28d9;

  font-size: 12px;
  font-weight: 700;
}

.customTable {
  border-collapse: separate;
  border-spacing: 0;
}

.customTable tbody td {
  padding: 10px 12px;

  border-right: 1px solid #e1e8f0;
  border-bottom: 1px solid #e1e8f0;

  background: #fff;
}

.customTable tbody tr:nth-child(even) td {
  background: #f7fbff;
}

.customTable tbody tr:hover td {
  background: #edf5ff;
}

.customTable tbody td {
  height: 38px;
  padding: 6px 10px;
  vertical-align: middle;
  font-size: 13px;
}

.customTable th:nth-child(1),
.customTable td:nth-child(1) {
  width: 12%;
}

.customTable th:nth-child(2),
.customTable td:nth-child(2) {
  width: 14%;
}

.customTable th:nth-child(3),
.customTable td:nth-child(3) {
  width: 17%;
}

.customTable th:nth-child(4),
.customTable td:nth-child(4) {
  width: 19%;
}

.customTable th:nth-child(5),
.customTable td:nth-child(5) {
  width: 19%;
}

.customTable th:nth-child(6),
.customTable td:nth-child(6) {
  width: 9%;
}

.customTable th:nth-child(7),
.customTable td:nth-child(7) {
  width: 10%;
}

.pagination-footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 18px 28px;
  background: #f8fbff;
}

.pagination-footer {
  position: relative;

  display: flex;
  align-items: center;
  justify-content: center;

  min-height: 78px;
  padding: 16px 28px;

  background: #f8fbff;
  border-top: 1px solid #dbe5f0;
}

.entries-info {
  position: absolute;
  left: 22px;

  font-size: 13px;
  color: #64748b;
  font-weight: 500;
}

.page-number {
  margin: 0 60px;

  font-size: 14px;
  font-weight: 600;
  color: #1e293b;
}


.pagination-btn {
  min-width: 92px;
  height: 38px;

  padding: 6px 14px;

  border: 1px solid #1769ff;
  border-radius: 8px;

  background: #fff;
  color: #1769ff;

  font-size: 13px;
  font-weight: 600;

  transition: all 0.2s ease;
}

.pagination-btn.next-btn {
  background: #1769ff;
  color: #fff;
}

.pagination-btn:hover:not(:disabled) {
  transform: translateY(-1px);
  box-shadow: 0 4px 10px rgba(23, 105, 255, 0.18);
}


`;

class ComponentList extends React.Component {
  theadRef = React.createRef();
  tableScrollRef = React.createRef();

  state = {
    isLoading: true,
    BeneficiariesDetail: [],
    backupData: [],
    apiLoading: false,
    apiPage: 1,
    excesProjectWithExcludeComponent: [],
    excesProjectInCaseOfCity: [],
    ScoreCard: "",
    headerHeight: 0,
    page: 1,
    limit: 25,
  };

  requestId = 0;
  pageCache = {};

  componentDidMount = async (background = false) => {
    const currentRequestId = ++this.requestId;

    this.setState({ isLoading: !background });

    const schemeName = get(this.props, "SchemesdataFilterType");

    try {
      if (get(this.props, "graphtype") === "Sanctioned") {
        if (this.props.dataFilterType === "constituency") {
          if (this.props.assembly) {
            
            const { data } = await Axios.get(
              `${BASE_URL}/project-details/sanctionbeneficiaries/sanction/assembly/${this.props.assembly.value}`,
              {
                params: {
                  schemeName,
                  page: this.state.apiPage,
                  limit: 50,
                },
              },
            );
            if (currentRequestId !== this.requestId) return;
            // this.setState({ BeneficiariesDetail: data, isLoading: false });
            this.pageCache[this.state.apiPage * 2 - 1] = data.slice(0, 25);
            this.pageCache[this.state.apiPage * 2] = data.slice(25, 50);
            this.setState({
              BeneficiariesDetail: data.slice(0, 25),
              backupData: data.slice(25, 50),
              isLoading: false,
            });
          } else {
            const { data } = await Axios.get(
              `${BASE_URL}/project-details/sanctionbeneficiaries/sanction/constituency/${this.props.constituency.value}`,
              {
                params: {
                  schemeName,
                  page: this.state.apiPage,
                  limit: 50,
                },
              },
            );
            if (currentRequestId !== this.requestId) return;
            // this.setState({ BeneficiariesDetail: data, isLoading: false });
            this.pageCache[this.state.apiPage * 2 - 1] = data.slice(0, 25);
            this.pageCache[this.state.apiPage * 2] = data.slice(25, 50);
            this.setState({
              BeneficiariesDetail: data.slice(0, 25),
              backupData: data.slice(25, 50),
              isLoading: false,
            });
          }
        } else {
          if (this.props.isDist) {
            const { data } = await Axios.get(
              `${BASE_URL}/project-details/sanctionbeneficiaries/sanction/district/${this.props.districtCode.value}`,
              {
                params: {
                  schemeName,
                  page: this.state.apiPage,
                  limit: 50,
                },
              },
            );
            if (currentRequestId !== this.requestId) return;
            // this.setState({ BeneficiariesDetail: data, isLoading: false });
            this.pageCache[this.state.apiPage * 2 - 1] = data.slice(0, 25);
            this.pageCache[this.state.apiPage * 2] = data.slice(25, 50);

            this.setState({
              BeneficiariesDetail: data.slice(0, 25),
              backupData: data.slice(25, 50),
              isLoading: false,
            });
          } else {
            if (currentRequestId !== this.requestId) return;
            const { data } = await Axios.get(
              `${BASE_URL}/project-details/sanctionbeneficiaries/sanction/City/${this.props.cityCode.value}`,
              {
                params: {
                  schemeName,
                  page: this.state.apiPage,
                  limit: 50,
                },
              },
            );
            if (currentRequestId !== this.requestId) return;
            this.pageCache[this.state.apiPage * 2 - 1] = data.slice(0, 25);
            this.pageCache[this.state.apiPage * 2] = data.slice(25, 50);
            // this.setState({ BeneficiariesDetail: data, isLoading: false });
            this.setState({
              BeneficiariesDetail: data.slice(0, 25),
              backupData: data.slice(25, 50),
              isLoading: false,
            });
          }
        }
      }
      if (get(this.props, "graphtype") === "Grounded") {
        if (this.props.dataFilterType === "constituency") {
          if (this.props.assembly) {
            const { data } = await Axios.get(
              `${BASE_URL}/project-details/sanctionbeneficiaries/Grounded/assembly/${this.props.assembly.value}`,
              {
                params: {
                  schemeName,
                  page: this.state.apiPage,
                  limit: 50,
                },
              },
            );
            if (currentRequestId !== this.requestId) return;
            this.pageCache[this.state.apiPage * 2 - 1] = data.slice(0, 25);
            this.pageCache[this.state.apiPage * 2] = data.slice(25, 50);
            // this.setState({ BeneficiariesDetail: data, isLoading: false });
            this.setState({
              BeneficiariesDetail: data.slice(0, 25),
              backupData: data.slice(25, 50),
              isLoading: false,
            });
          } else {
            const { data } = await Axios.get(
              `${BASE_URL}/project-details/sanctionbeneficiaries/Grounded/constituency/${this.props.constituency.value}`,
              {
                params: {
                  schemeName,
                  page: this.state.apiPage,
                  limit: 50,
                },
              },
            );
            if (currentRequestId !== this.requestId) return;
            this.pageCache[this.state.apiPage * 2 - 1] = data.slice(0, 25);
            this.pageCache[this.state.apiPage * 2] = data.slice(25, 50);
            // this.setState({ BeneficiariesDetail: data, isLoading: false });
            this.setState({
              BeneficiariesDetail: data.slice(0, 25),
              backupData: data.slice(25, 50),
              isLoading: false,
            });
          }
        } else {
          if (this.props.isDist) {
            const { data } = await Axios.get(
              `${BASE_URL}/project-details/sanctionbeneficiaries/Grounded/district/${this.props.districtCode.value}`,
              {
                params: {
                  schemeName,
                  page: this.state.apiPage,
                  limit: 50,
                },
              },
            );
            if (currentRequestId !== this.requestId) return;
            this.pageCache[this.state.apiPage * 2 - 1] = data.slice(0, 25);
            this.pageCache[this.state.apiPage * 2] = data.slice(25, 50);
            // this.setState({ BeneficiariesDetail: data, isLoading: false });
            this.setState({
              BeneficiariesDetail: data.slice(0, 25),
              backupData: data.slice(25, 50),
              isLoading: false,
            });
          } else {
            const { data } = await Axios.get(
              `${BASE_URL}/project-details/sanctionbeneficiaries/Grounded/City/${this.props.cityCode.value}`,
              {
                params: {
                  schemeName,
                  page: this.state.apiPage,
                  limit: 50,
                },
              },
            );
            if (currentRequestId !== this.requestId) return;
            this.pageCache[this.state.apiPage * 2 - 1] = data.slice(0, 25);
            this.pageCache[this.state.apiPage * 2] = data.slice(25, 50);
            // this.setState({ BeneficiariesDetail: data, isLoading: false });
            this.setState({
              BeneficiariesDetail: data.slice(0, 25),
              backupData: data.slice(25, 50),
              isLoading: false,
            });
          }
        }
      }

      if (get(this.props, "graphtype") === "Completed") {
        if (this.props.dataFilterType === "constituency") {
          if (this.props.assembly) {
            const { data } = await Axios.get(
              `${BASE_URL}/project-details/sanctionbeneficiaries/Completed/assembly/${this.props.assembly.value}`,
              {
                params: {
                  schemeName,
                  page: this.state.apiPage,
                  limit: 50,
                },
              },
            );
            if (currentRequestId !== this.requestId) return;
            this.pageCache[this.state.apiPage * 2 - 1] = data.slice(0, 25);
            this.pageCache[this.state.apiPage * 2] = data.slice(25, 50);
            // this.setState({ BeneficiariesDetail: data, isLoading: false });
            this.setState({
              BeneficiariesDetail: data.slice(0, 25),
              backupData: data.slice(25, 50),
              isLoading: false,
            });
          } else {
        
            const { data } = await Axios.get(
              `${BASE_URL}/project-details/sanctionbeneficiaries/Completed/constituency/${this.props.constituency.value}`,
              {
                params: {
                  schemeName,
                  page: this.state.apiPage,
                  limit: 50,
                },
              },
            );
            if (currentRequestId !== this.requestId) return;
            this.pageCache[this.state.apiPage * 2 - 1] = data.slice(0, 25);
            this.pageCache[this.state.apiPage * 2] = data.slice(25, 50);
            // this.setState({ BeneficiariesDetail: data, isLoading: false });
            this.setState({
              BeneficiariesDetail: data.slice(0, 25),
              backupData: data.slice(25, 50),
              isLoading: false,
            });
          }
        } else {
          if (this.props.isDist) {
            const { data } = await Axios.get(
              `${BASE_URL}/project-details/sanctionbeneficiaries/Completed/district/${this.props.districtCode.value}`,
              {
                params: {
                  schemeName,
                  page: this.state.apiPage,
                  limit: 50,
                },
              },
            );
            if (currentRequestId !== this.requestId) return;
            this.pageCache[this.state.apiPage * 2 - 1] = data.slice(0, 25);
            this.pageCache[this.state.apiPage * 2] = data.slice(25, 50);
            // this.setState({ BeneficiariesDetail: data, isLoading: false });
            this.setState({
              BeneficiariesDetail: data.slice(0, 25),
              backupData: data.slice(25, 50),
              isLoading: false,
            });
          } else {
            const { data } = await Axios.get(
              `${BASE_URL}/project-details/sanctionbeneficiaries/Completed/City/${this.props.cityCode.value}`,
              {
                params: {
                  schemeName,
                  page: this.state.apiPage,
                  limit: 50,
                },
              },
            );
            if (currentRequestId !== this.requestId) return;
            this.pageCache[this.state.apiPage * 2 - 1] = data.slice(0, 25);
            this.pageCache[this.state.apiPage * 2] = data.slice(25, 50);
            // this.setState({ BeneficiariesDetail: data, isLoading: false });
            this.setState({
              BeneficiariesDetail: data.slice(0, 25),
              backupData: data.slice(25, 50),
              isLoading: false,
            });
          }
        }
      }
        
      if (get(this.props, "graphtype") === "HousesSanctioned") {
           
        if (this.props.isDist) {
          const { data } = await Axios.get(
            `${BASE_URL}/project-details/sanctionbeneficiaries/sanction/district/${this.props.districtCode.value}`,
            {
              params: {
                schemeName,
              },
            },
          );
          if (currentRequestId !== this.requestId) return;
          this.setState({
            BeneficiariesDetail: _.filter(
              data,
              (o) => o.component === get(this.props, "slicetype"),
            ),
            isLoading: false,
          });
        } else {
          const { data } = await Axios.get(
            `${BASE_URL}/project-details/sanctionbeneficiaries/sanction/City/${this.props.cityCode.value}`,
            {
              params: {
                schemeName,
              },
            },
          );
          if (currentRequestId !== this.requestId) return;
          this.setState({
            BeneficiariesDetail: _.filter(
              data,
              (o) => o.component === get(this.props, "slicetype"),
            ),
            isLoading: false,
          });
        }
      }

      if (get(this.props, "graphtype") === "BeneficiariesunderCLSS") {
        if (this.props.isDist) {
          if (get(this.props, "slicetype") === "MIG") {
     
            const { data } = await Axios.get(
              `${BASE_URL}/project-details/BeneficiariesunderCLSS/MIG/district/${this.props.districtCode.value}`,
              {
                params: {
                  schemeName,
                },
              },
            );

            this.setState({ BeneficiariesDetail: data, isLoading: false });
          } else {
    
            const { data } = await Axios.get(
              `${BASE_URL}/project-details/BeneficiariesunderCLSS/EWS/district/${this.props.districtCode.value}`,
              {
                params: {
                  schemeName,
                },
              },
            );

            this.setState({ BeneficiariesDetail: data, isLoading: false });
          }
        } else {
          if (get(this.props, "slicetype") === "MIG") {

            const { data } = await Axios.get(
              `${BASE_URL}/project-details/BeneficiariesunderCLSS/MIG/City/${this.props.cityCode.value}`,
              {
                params: {
                  schemeName,
                },
              },
            );

            this.setState({ BeneficiariesDetail: data, isLoading: false });
          } else {
    

            const { data } = await Axios.get(
              `${BASE_URL}/project-details/BeneficiariesunderCLSS/EWS/City/${this.props.cityCode.value}`,
              {
                params: {
                  schemeName,
                },
              },
            );

            this.setState({ BeneficiariesDetail: data, isLoading: false });
          }
        }
      }
    } catch (err) {
      this.setState({ isLoading: false });
      toast.error("Something went wronge.");
    }

    // measure header after first mount
    this.updateHeaderHeight();
  };

  // componentDidUpdate(prevProps, prevState) {
  //   if (prevState.isLoading !== this.state.isLoading || prevState.BeneficiariesDetail !== this.state.BeneficiariesDetail) {
  //     this.updateHeaderHeight();
  //   }
  // }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.page !== this.state.page) {
      if (this.tableScrollRef.current) {
        this.tableScrollRef.current.scrollTop = 0;
      }

      if (this.state.page % 2 === 0) {
        const nextApiPage = this.state.page / 2 + 1;
        const nextPage = this.state.page + 1;

        if (!this.pageCache[nextPage]) {
          this.setState(
            {
              apiPage: nextApiPage,
            },
            () => {
              this.componentDidMount(true);
            },
          );
        }
      }
    }

    if (
      prevState.isLoading !== this.state.isLoading ||
      prevState.BeneficiariesDetail !== this.state.BeneficiariesDetail
    ) {
      this.updateHeaderHeight();
    }
  }

  // code from CustomTable to measure header height --------------------krishna
  updateHeaderHeight = () => {
    try {
      const el = this.theadRef && this.theadRef.current;
      if (el) {
        const h = el.clientHeight || el.offsetHeight || 0;
        if (this.state.headerHeight !== h) this.setState({ headerHeight: h });
      }
    } catch (e) {
      // ignore measurement errors
    }
  };

  render() {
    const { isLoading, BeneficiariesDetail } = this.state;
    const hideColumn = get(this.props, "hideColumn")
      ? get(this.props, "hideColumn")
      : [];

    const startEntry = (this.state.page - 1) * 25 + 1;

    const endEntry = startEntry + BeneficiariesDetail.length - 1;

    return (
      <Wrapper>
        <h3>Beneficiaries List . {get(this.props, "CSMCNo")}</h3>
        <>
          {/* <div style={{ position: 'relative', maxHeight: '60vh', overflowY: 'auto' }}> */}
          <div
            style={{
              position: "relative",
              height: "calc(100vh - 180px)",
              display: "flex",
              flexDirection: "column",
            }}
          >
            <div
              ref={this.tableScrollRef}
              style={{ flex: 1, overflowY: "auto", overflowX: "auto" }}
            >
              <Table
                className="bg-c-white customTable"
                id="MonitoringofProgress"
                style={{ minHeight: isLoading ? 360 : undefined }}
              >
                <thead
                  ref={this.theadRef}
                  // className="label label-warning text-white text-center"
                  className="beneficiary-header"
                  style={{
                    backgroundColor: "#002b49",
                    position: "sticky",
                    top: 0,
                    zIndex: 10,
                  }}
                >
                  <tr style={{ textAlign: "center" }}>
                    {/*  <th rowSpan={2} style={{ width: 30, maxWidth: 30 }} className="center">
                      Sr.
                    </th> */}
                    {/* <th rowSpan={2}>Sanctioned <br /> Date</th>
                  <th rowSpan={2}>District Name</th>
                  <th rowSpan={2}>ULB Name</th>
                  <th rowSpan={2}>Beneficiaries Name</th>
                  <th rowSpan={2}>Father's Name</th>
                  <th rowSpan={2}>Gender</th> */}
                    {/*   <th rowSpan={2}>Age</th> */}
                    {/*    <th rowSpan={2}>Religion</th> */}
                    {/* <th rowSpan={2}>Component</th> */}

                    <th rowSpan={2}>
                      <FaCalendarAlt />
                      <span>
                        Sanctioned
                        <br />
                        Date
                      </span>
                    </th>

                    <th rowSpan={2}>
                      <FaMapMarkerAlt />
                      <span>District Name</span>
                    </th>

                    <th rowSpan={2}>
                      <FaUniversity />
                      <span>ULB Name</span>
                    </th>

                    <th rowSpan={2}>
                      <FaUser />
                      <span>Beneficiaries Name</span>
                    </th>

                    <th rowSpan={2}>
                      <FaUser />
                      <span>Father's Name</span>
                    </th>

                    <th rowSpan={2}>
                      <FaVenusMars />
                      <span>Gender</span>
                    </th>

                    <th rowSpan={2}>
                      <FaThLarge />
                      <span>Component</span>
                    </th>
                  </tr>
                </thead>

                <tbody>
                  {map(BeneficiariesDetail, (obj, i) => {
                    return (
                      // <tr key={get(obj, "ProjectCode")}>
                      <tr
                        key={`${get(obj, "ProjectCode")}-${get(obj, "BeneficiaryCode")}-${this.state.apiPage}-${i}`}
                      >
                        {/* https://dashboard.pmay-urban.gov.in/v1/beneficiary/mis_BeneficiaryProfiles?benefCode=018000481486200021 */}

                        {/* <td>{get(obj, "SanctionedDate") || "-"}</td> */}
                        <td>
                          <div className="table-cell-with-icon">
                            <FaCalendarAlt className="date-icon" />
                            <span>{get(obj, "SanctionedDate") || "-"}</span>
                          </div>
                        </td>
                        {/* <td>{get(obj, "DistrictName") || "-"}</td> */}
                        <td>
                          <div className="table-cell-with-icon">
                            <FaMapMarkerAlt className="district-icon" />
                            <span>{get(obj, "DistrictName") || "-"}</span>
                          </div>
                        </td>
                        {/* <td className="city-name">
                          {get(obj, "CityName") || "-"}
                        </td> */}
                        <td className="city-name">
                          <div className="table-cell-with-icon">
                            <FaUniversity className="ulb-icon" />
                            <span>{get(obj, "CityName") || "-"}</span>
                          </div>
                        </td>
                        {/* https://dashboard.pmay-urban.gov.in/admin-services/NHB_CLSS_BeneficiaryReport?scheme=PMAY-U-2.0&benefCode=BR032151224109432076 */}

                        {get(obj, "scheme_uniq_id") === 3 &&
                        (get(obj, "component") === "BLC" ||
                          get(obj, "component") === "AHP" ||
                          get(obj, "component") === "ISSR") ? (
                          <td>
                         {/* <a
                            title={_.get(obj, "BeneficiaryName")}
                            target="_blank"
                            rel="noopener noreferrer"
                            href={`/admin-services/NHB_CLSS_BeneficiaryReport?benefCode=${encodeURIComponent(
                                _.get(obj, "BeneficiaryCode")
                            )}`}
                            onClick={() => {
                                const key = `beneficiary_${_.get(obj, "BeneficiaryCode")}`;

                                localStorage.setItem(
                                    key,
                                    JSON.stringify(obj)
                                );

                                console.log("SAVED =>", key);
                                console.log("DATA =>", obj);
                            }}
                        >
                            {get(obj, "BeneficiaryName") || "-"}
                        </a> */}
                            <a
                              title={_.get(obj, "BeneficiaryName")}
                              target="_blank"
                              rel="noopener noreferrer"
                              href={`/admin-services/NHB_CLSS_BeneficiaryReport?scheme=PMAY-U&component=${encodeURIComponent(
                                _.get(obj, "component")
                              )}&benefCode=${encodeURIComponent(
                                _.get(obj, "BeneficiaryCode")
                              )}`}
                              // onClick={() => {
                              //   const key = `beneficiary_${_.get(obj, "BeneficiaryCode")}`;

                              //   localStorage.setItem(
                              //     key,
                              //     JSON.stringify(obj)
                              //   );

                              //   console.log("SAVED =>", key);
                              //   console.log("DATA =>", obj);
                              // }}
                              onClick={() => {
                                const benefCode = _.get(obj, "BeneficiaryCode");

                                const blcData = {
                                    ...obj,
                                    projectCode: _.get(obj, "ProjectCode"),
                                };

                                localStorage.setItem(
                                    `BLC_benef_Details_${benefCode}`,
                                    JSON.stringify(blcData)
                                );
                            }}
                            >
                              {get(obj, "BeneficiaryName") || "-"}
                            </a>
                          </td>
                        ) : get(obj, "scheme_uniq_id") === 4 &&
                          (get(obj, "component") === "BLC" ||
                            get(obj, "component") === "AHP" ||
                            get(obj, "component") === "ISSR") ? (
                          <td>
                            <a
                              title={_.get(obj, "BeneficiaryName")}
                              target="_blank"
                              rel="noopener noreferrer"
                              // href={`/admin-services/NHB_CLSS_BeneficiaryReport?scheme=PMAY-U-2.0&benefCode=${_.get(obj, "BeneficiaryCode")}`}
                              href={`/admin-services/NHB_CLSS_BeneficiaryReport?scheme=PMAY-U-2.0&component=${encodeURIComponent(
                                _.get(obj, "component")
                              )}&benefCode=${encodeURIComponent(
                                _.get(obj, "BeneficiaryCode")
                              )}`}
                            >
                              {get(obj, "BeneficiaryName") || "-"}
                            </a>
                          </td>
                        ) : get(obj, "component") === "CLSS" ? (
                          <td>
                            <a
                              title={_.get(obj, "BeneficiaryName")}
                              target="_blank"
                              rel="noopener noreferrer"
                              href={`/admin-services/NHB_Beneficiary_ReportForCLSS?beneficiaryCode=${_.get(obj, "BeneficiaryCode")}`}
                            >
                              {get(obj, "BeneficiaryName") || "-"}
                            </a>
                          </td>
                        ) : (
                          <td>{get(obj, "BeneficiaryName") || "-"}</td>
                        )}
                        <td>{get(obj, "FatherName") || "-"}</td>
                        {/* <td>{get(obj, "Gender") || "-"}</td> */}
                        <td>
                          <div className="table-cell-with-icon">
                            <FaVenusMars className="gender-icon" />
                            <span>{get(obj, "Gender") || "-"}</span>
                          </div>
                        </td>
                        <td>
                          {get(obj, "component") ? (
                            <span className="component-badge">
                              {get(obj, "component")}
                            </span>
                          ) : (
                            "-"
                          )}
                        </td>
                        {/* <td>{get(obj, "component") || "-"}</td> */}
                      </tr>
                    );
                  })}
                </tbody>
              </Table>
            </div>
            <div className="pagination-footer">
              <div className="entries-info">
                Showing {startEntry} to {endEntry} of entries
              </div>

              <button
                className="pagination-btn"
                disabled={this.state.page === 1}
                onClick={() => {
                  const previousPage = this.state.page - 1;
                  const previousPageData = this.pageCache[previousPage] || [];

                  this.setState({
                    page: previousPage,
                    BeneficiariesDetail: previousPageData,
                    isLoading: false,
                  });
                }}
              >
                &lt; Previous
              </button>

              <span className="page-number">Page {this.state.page}</span>
              <button
                className="pagination-btn next-btn"
                disabled={!this.pageCache[this.state.page + 1]?.length}
                onClick={() => {
                  const nextPage = this.state.page + 1;
                  const nextPageData = this.pageCache[nextPage];

                  if (nextPageData?.length) {
                    this.setState({
                      page: nextPage,
                      BeneficiariesDetail: nextPageData,
                      isLoading: false,
                    });
                  }
                }}
              >
                Next &gt;
              </button>
            </div>

            {isLoading &&
              (() => {
                const overlayTop =
                  this.state.headerHeight && this.state.headerHeight > 0
                    ? this.state.headerHeight
                    : 48;
                return (
                  <div
                    style={{
                      position: "absolute",
                      top: overlayTop,
                      left: 0,
                      right: 0,
                      bottom: 0,
                      backgroundColor: "rgba(255,255,255,0.93)",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      zIndex: 5,
                    }}
                  >
                    <Loader title="Report Generating..." />
                  </div>
                );
              })()}
          </div>
        </>
      </Wrapper>
    );
  }
}

export default ComponentList;
